import React from 'react';

const DataWellSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500" className="w-full h-full">
        {/* Background with tech grid */}
        <defs>
            <pattern id="grid" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#1E3A8A" strokeWidth="0.5" opacity="0.2" />
            </pattern>
            <linearGradient id="dataFlow" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3B82F6" stopOpacity="1" />
                <stop offset="100%" stopColor="#7C3AED" stopOpacity="0.8" />
            </linearGradient>
        </defs>

        {/* Grid background */}
        <rect width="400" height="500" fill="#0F172A" />
        <rect width="400" height="500" fill="url(#grid)" />

        {/* Server/Data Center at Top */}
        <g transform="translate(150, 20)">
            <rect x="0" y="0" width="100" height="60" rx="5" fill="#1E40AF" />
            <rect x="10" y="10" width="80" height="40" rx="3" fill="#2563EB" />
            <circle cx="75" cy="30" r="3" fill="#60A5FA">
                <animate attributeName="opacity" values="1;0.2;1" dur="2s" repeatCount="indefinite" />
            </circle>
            <circle cx="20" cy="20" r="2" fill="#34D399" />
            <circle cx="20" cy="30" r="2" fill="#60A5FA" />
            <circle cx="20" cy="40" r="2" fill="#F87171" />
        </g>

        {/* Digital Oil Well Structure */}
        <g transform="translate(175, 80)">
            <path d="M25 0 L25 350" stroke="#3B82F6" strokeWidth="6" fill="none" />

            <g>
                <rect x="22" y="50" width="6" height="15" fill="url(#dataFlow)" opacity="0.8">
                    <animate attributeName="y" from="50" to="380" dur="3s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0.8;0.2;0.8" dur="3s" repeatCount="indefinite" />
                </rect>
                <rect x="22" y="150" width="6" height="15" fill="url(#dataFlow)" opacity="0.6">
                    <animate attributeName="y" from="150" to="380" dur="3s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0.6;0.2;0.6" dur="3s" repeatCount="indefinite" />
                </rect>
            </g>

            <g transform="translate(25, 100)">
                <line x1="0" y1="0" x2="50" y2="0" stroke="#3B82F6" strokeWidth="4" />
                <rect x="50" y="-15" width="30" height="30" rx="5" fill="#1E40AF" />
                <text x="60" y="5" fill="#60A5FA" fontSize="12">01</text>
            </g>

            <g transform="translate(25, 200)">
                <line x1="0" y1="0" x2="-50" y2="0" stroke="#3B82F6" strokeWidth="4" />
                <rect x="-80" y="-15" width="30" height="30" rx="5" fill="#1E40AF" />
                <text x="-70" y="5" fill="#60A5FA" fontSize="12">10</text>
            </g>

            <g transform="translate(0, 350)">
                <path d="M-50 0 C-30 20, 80 20, 100 0" fill="none" stroke="url(#dataFlow)" strokeWidth="4" />
                <path d="M-40 10 C-20 30, 70 30, 90 10" fill="none" stroke="url(#dataFlow)" strokeWidth="4" />
                <path d="M-30 20 C-10 40, 60 40, 80 20" fill="none" stroke="url(#dataFlow)" strokeWidth="4" />
            </g>
        </g>

        <g transform="translate(20, 100)" opacity="0.1">
            <text fill="#60A5FA" fontFamily="monospace">
                <tspan x="0" y="0">01001100</tspan>
                <tspan x="0" y="20">11000101</tspan>
                <tspan x="0" y="40">01011100</tspan>
            </text>
        </g>
        <g transform="translate(300, 200)" opacity="0.1">
            <text fill="#60A5FA" fontFamily="monospace">
                <tspan x="0" y="0">10110011</tspan>
                <tspan x="0" y="20">01001010</tspan>
                <tspan x="0" y="40">11010001</tspan>
            </text>
        </g>
    </svg>
);

export default DataWellSVG;